(function($) {

    //---------------------
    // Set variables for this document
    //---------------------
    var menuOpened = false;
    var navHeight = $(".nav").outerHeight();
    var subHeight = $('.nav__sub_wrapper').is(':visible') ? $('.nav__sub_wrapper').outerHeight(true) : 0;
    var infoHeight = 0;
    var fullHeight = navHeight + subHeight;
    if ($(".navigation-info").length) {
        infoHeight = $(".navigation-info").height();
        fullHeight = fullHeight + infoHeight;
    }



    //---------------------
    // Set variables for css on load and resize
    //---------------------
    document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
    document.documentElement.style.setProperty('--menu-full-height', `${fullHeight}px`);
    document.documentElement.style.setProperty('--menu-sub-height', `${subHeight}px`);
    var w = $(window).width();
    window.addEventListener('resize', () => {
        if ($(window).width() == w) return;
        w = $(window).width();
        navHeight = $(".nav").outerHeight();
        subHeight = $('.nav__sub_wrapper').is(':visible') ? $('.nav__sub_wrapper').outerHeight(true) : 0;
        fullHeight = navHeight + subHeight;
        infoHeight = 0;
        if ($(".navigation-info").length) {
            infoHeight = $(".navigation-info").height();
            fullHeight = fullHeight + infoHeight;
        }
        document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
        document.documentElement.style.setProperty('--menu-full-height', `${fullHeight}px`);
        document.documentElement.style.setProperty('--menu-sub-height', `${subHeight}px`);
    });


    //---------------------
    // Toggle menu on hamburger click
    //---------------------
    // $(".navigation__hamburger").not('.navigation__search-close').on("click", function () {
    //     $(".navigation").toggleClass("opened");
    //     menuOpened = !menuOpened;
    //     if(menuOpened){
    //         $(".navigation__menu").addClass("navigation__menu--active");
    //         $('html').addClass('overflow_hidden');
    //         if (infoHeight > 0 && $(document).scrollTop() <= infoHeight) {
    //             var $infoHeightActual = infoHeight - $(window).scrollTop();
    //             $(".navigation.opened").css("top", $infoHeightActual);
    //         }
    //     } else {
    //         $(".navigation__menu").removeClass("navigation__menu--active");
    //         $('html').removeClass('overflow_hidden');
    //         if (infoHeight > 0 && $(document).scrollTop() <= infoHeight) {
    //             $(".navigation").css("top", '');
    //         }
    //     }
    //     $(".navigation__hamburger-icon").toggleClass("navigation__hamburger-icon--opened");
    // })

    function sidebarOpen(){
        $('html').addClass('overflow_hidden');
        $('body').addClass('has-modal-nav');
        $(".navigation__hamburger-icon").addClass("navigation__hamburger-icon--opened");
        $(".navigation__hamburger").addClass("navigation__hamburger--opened");
        setTimeout(() => {
            $("[data-modal-id='nav']").addClass('opened')
            $('body').addClass('has-modal')
        }, 1)
        // Trigger event
        $(document).trigger("modal_opened", ['nav'])
    }

    function sidebarClose(){
        $(".navigation__hamburger-icon").removeClass("navigation__hamburger-icon--opened");
        $(".navigation__hamburger").removeClass("navigation__hamburger--opened");
        $('html').removeClass('overflow_hidden');
        $('body').removeClass('has-modal').removeClass('has-modal-nav');
        $("[data-modal-id='nav']").css('transform', '').removeClass('opened');
    }

    // Close modal on body overlay click
    $(document).on("click", "body.has-modal .body-content", function (e) {
        sidebarClose()
    })
    // Close modal on Escape
    $(document).keyup(function (e) {
        if (e.key === "Escape") {
            sidebarClose()
        }
    });

    $(".navigation__hamburger").not('.navigation__search-close').on("click", function () {
        if($(this).hasClass('navigation__hamburger--opened')){
            sidebarClose();
        } else {
            sidebarOpen();
        }
    })


    $('.nav_m__main_link-child').click(function (){
        $(this).next('.nav_m__side').addClass('nav_m__side-open');
    });
    $('.nav_m__side_title').click(function (){
        $(this).parent('.nav_m__side').removeClass('nav_m__side-open');
    });


    //---------------------
    // Open menu on click or hover
    //---------------------
    // $(".navigation__items-has-submenu").each(function(){
    //     let $submenuHeight = $(this).children(".navigation__submenu").outerHeight();
    //     $(this).children(".navigation__submenu").css('max-height', '0');
    //     $(this).on("click", function (e) {
    //         e.stopPropagation();
    //         if ($(this).hasClass('navigation__item--opened')){
    //             $(this).children(".navigation__submenu").removeClass("navigation__submenu--opened").css('max-height', '0');
    //             $(this).removeClass("navigation__item--opened");
    //         } else {
    //             $(this).children(".navigation__submenu").addClass("navigation__submenu--opened").css('max-height', $submenuHeight+'px');
    //             $(this).addClass("navigation__item--opened");
    //         }
    //     })
    // });


    //---------------------
    // Manipulate menu on scroll
    //---------------------
    // function navAnimationClasses() {
    //     if ($(document).scrollTop() === 0 ) {
    //         $('.navigation').addClass("navigation-top");
    //     }
    //     if ($(document).scrollTop() > fullHeight || $(document).scrollTop() > fullHeight && $('body').hasClass('sidebar-cart-opened')) {
    //         $('.navigation').addClass("scrolled").addClass("nav_hidden").addClass("scrollUpFixed").removeClass("navigation-top");
    //         $('.navigation--relative').css("padding-top", fullHeight - infoHeight);
    //         $('.navigation-header').addClass('navigation-bg');
    //     } else {
    //         $('.navigation').removeClass("scrolled").removeClass('nav_animate');
    //         $('.navigation-header').removeClass('navigation-bg');
    //     }
    //     if ($(document).scrollTop() <= infoHeight || $(document).scrollTop() <= infoHeight && $('body').hasClass('sidebar-cart-opened')) {
    //         $('.navigation--relative').css("padding-top", '');
    //         $('.navigation').addClass("navigation-top").removeClass("scrollUpFixed");
    //     }
    // }


    //---------------------
    // Set sub menu left offset if overflows document
    //---------------------
    function setNavOffset() {
        $('.navigation__items > .navigation__item').each(function() {
            var $this = $(this);
            var $linksWidth = $(this).children('.navigation__submenu').outerWidth();
            var $documentWidth = $(window).outerWidth();
            var $offset = $(this).offset().left;
            var left = ($documentWidth - $offset) - $linksWidth - 15;
            if ($linksWidth > $documentWidth - $offset) {
                $this.children('.navigation__submenu').css('left', left)
            } else {
                $this.children('.navigation__submenu').css('left', '')
            }
        });
    }

    //---------------------
    // Add white background and overlay when hover to navigation
    //---------------------
    $('.nav__sub_link-child').on("mouseenter", function (e) {
        $('.nav__sub_link-child').removeClass('hovered');
        $('body').addClass('nav-overlay');
        $(this).addClass('hovered');
        setTimeout(() => {
            $(this).closest('.nav__sub_items').addClass('nav__sub_transition');
        }, 200)
    })
    $('.nav__sub_items').on("mouseleave", function (e) {
        $('body').removeClass('nav-overlay');
        $('.nav__sub_link-child').removeClass('hovered');
        $(this).removeClass('nav__sub_transition');
    })
    $('.nav__right_menu_items').on("mouseenter", function (e) {
        $('body').addClass('nav-overlay');
        setTimeout(() => {
            $(this).addClass('nav__sub_transition');
        }, 200)
    })
    $('.nav__right_menu_items').on("mouseleave", function (e) {
        $('.nav__sub_link-child').removeClass('hovered');
        $('body').removeClass('nav-overlay');
        $(this).removeClass('nav__sub_transition');
    })


    //---------------------
    // On scroll functions
    //---------------------
    let lastScroll = 0;
    $(window).on('scroll',function() {
        var scroll = $(window).scrollTop();
        // if(lastScroll - scroll > 0 && scroll > fullHeight) {
        //     $(".nav").addClass("scrollUp ").removeClass("nav_hidden").addClass('nav_animate');
        // } else {
        //     $(".nav").removeClass("scrollUp");
        // }

        if(scroll > fullHeight) {
            $('body').css('padding-top', navHeight)
            $(".nav").addClass("scrolled");
        } else {
            $(".nav").removeClass("scrolled");
            $('body').css('padding-top', '')
        }
        if(lastScroll - scroll > 0 && scroll > fullHeight) {
            $(".nav").addClass("scrollUp ").removeClass("nav_hidden").addClass('nav_animate');
        } else if (lastScroll - scroll < 0) {
            $(".nav").removeClass("scrollUp");
        }
        if(scroll > infoHeight) {
            $(".sidebar__nav").addClass("sidebar__nav-scrolled");
        } else {
            $(".sidebar__nav").removeClass("sidebar__nav-scrolled");
        }
        lastScroll = scroll;

        // navAnimationClasses();
    });




    $('.nav_m__header_link').on('click', function(e){
        let id = $(this).data('nav-open-category');
        if (!$(this).hasClass('active')){
            e.preventDefault();
            $('.nav_m__header_link').removeClass('active');
            $(this).addClass('active');
            $('.nav_m__main').removeClass('nav_m__main-active');
            $("[data-nav-category=" + id + "]").addClass('nav_m__main-active');
        } else {

        }
    });



    function onTouchNav() { //For bigger touch devices (tablets)
        var isTouchDevice = 'ontouchstart' in document.documentElement;

        if (isTouchDevice) {
            var lastTouchedLink = null;
            $('.nav__sub_link-child, .menu-item-has-children a').each(function(){
                $(this).on('touchstart', function(e) {
                    var $this = $(this);

                    // Pokud je kliknuto na jiný odkaz než ten poslední dotknutý
                    if (lastTouchedLink && !$this.is(lastTouchedLink)) {
                        lastTouchedLink.removeData('touched'); // Odstraníme 'data-touched' z předchozího odkazu
                        lastTouchedLink.parent().removeClass('active');
                    }


                    // Pokud odkaz nemá atribut 'data-touched', přidej ho a zruš defaultní chování odkazu
                    if (!$this.data('touched')) {

                        //PreventDefault only if desktop menu (991px)
                        var windowWidth = $(window).width();
                        if (windowWidth > 991) {
                            e.preventDefault(); // Zruší defaultní akci odkazu
                        }
                        window.addEventListener('resize', () => {
                            if ($(window).width() == windowWidth) return;
                            windowWidth = $(window).width();
                            if (windowWidth > 991) {
                                e.preventDefault(); // Zruší defaultní akci odkazu
                            }
                        });


                        $this.data('touched', true); // Nastaví, že byl dotyk zaznamenán
                        $this.parent().addClass('active');
                        $('body').addClass('nav-overlay');
                        lastTouchedLink = $this; // Uloží odkaz jako poslední dotknutý

                        // Přidání event listeneru na dokument
                        $(document).on('touchstart.outsideLink', function(event) {
                            // Pokud uživatel klikne mimo poslední dotknutý odkaz
                            if (!$(event.target).is(lastTouchedLink)) {
                                lastTouchedLink.removeData('touched'); // Odstraní data-touched
                                lastTouchedLink.parent().removeClass('active');
                                lastTouchedLink = null;
                                $('body').removeClass('nav-overlay');
                                $('.nav__sub_link-child').removeClass('hovered');

                                // Odeber event listener, už není potřeba
                                $(document).off('touchstart.outsideLink');
                            }
                        });
                    }
                });

            })
        }
    }


    //---------------------
    // On load functions
    //---------------------
    $(window).on('load',function() {
        setNavOffset();
        onTouchNav();
        if ($(document).scrollTop() === 0 ) {
            $('.navigation').addClass("navigation-top");
        }
    });


    //---------------------
    // On resize functions
    //---------------------
    var windowWidth = $(window).width();
    window.addEventListener('resize', () => {
        if ($(window).width() == windowWidth) return;
        windowWidth = $(window).width();
        // navAnimationClasses();
        setNavOffset();
    });


})(jQuery);